import { useLocation, useNavigate, useSearchParams } from "react-router-dom"

const MIN_SEARCH_PARAMS_SIZE_FOR_DAT_BOOKING_REDIRECT = 1
const MAX_SEARCH_PARAMS_SIZE_FOR_DAT_BOOKING_REDIRECT = 2

type PendoPayload = Record<string, string | null>

const handleNotAuthenticatedDATRedirect = (pendoPayload: PendoPayload) => {
  window.pendo.initialize({
    visitor: {
      id: 'AnonymousVisitor'
    }
  })
  if(window.pendo.isReady()) {
    window.pendo.track('DAT booking redirect', pendoPayload)
    window.pendo.clearSession()
  } else {
    setTimeout(() => {
      window.pendo.track('DAT booking redirect', pendoPayload)
      window.pendo.clearSession()
    }, 150)
  }
}

export function useDATBookingRedirect() {
  const location = useLocation()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  const hasRequiredRoutePattern = (currentPath: string) => {
    return currentPath.startsWith('/load/')
  }

  const getDATRedirectQueryParam = (currentPath: string) => {
    try {
      const envParam = searchParams.get('env')
      const hasEnvParam = !!envParam
      const hasAllowedQueryParamsSize = hasEnvParam
        ? searchParams.size === MAX_SEARCH_PARAMS_SIZE_FOR_DAT_BOOKING_REDIRECT
        : searchParams.size === MIN_SEARCH_PARAMS_SIZE_FOR_DAT_BOOKING_REDIRECT

      if (!hasAllowedQueryParamsSize || !hasRequiredRoutePattern(currentPath)) {
        return ''
      }

      const encodedQueryParamsString = location.search
        .replace(`?env=${envParam}&`, '')
        .replace(`&env=${envParam}`, '')

      return encodedQueryParamsString.startsWith('?')
        ? encodedQueryParamsString.slice(1)
        : encodedQueryParamsString
    } catch(error) {
      // eslint-disable-next-line no-console
      console.log('Error trying to get DAT redirect query param', error)
    }
  }

  const handleDatBookingRedirect = (currentPath: string, encodedQueryParamsString: string, isAuthenticated: boolean) => {
    if (hasRequiredRoutePattern(currentPath) && encodedQueryParamsString && window.pendo) {
      try {
        const decodedQueryParamsString = decodeURIComponent(encodedQueryParamsString)
        const stringParams = atob(decodedQueryParamsString)
        const mapSearchParams = new URLSearchParams(stringParams)

        const DATPostingId = mapSearchParams.get('datpostingid')

        if (DATPostingId) {
          const pendoPayload = {
            UserEmail: mapSearchParams.get('email') || null,
            DOTNumber: mapSearchParams.get('dot') || null,
            MCNumber: mapSearchParams.get('mc') || null,
            DATPostingId: mapSearchParams.get('datpostingid') || null,
            PostersRefId: mapSearchParams.get('postersrefid') || null,
            DateTime: mapSearchParams.get('datetime') || null,
            CarrierId: mapSearchParams.get('carrierid') || null
          }

          if (isAuthenticated) {
            window.pendo.track('DAT booking redirect', pendoPayload)
          }

          if(!isAuthenticated) {
            handleNotAuthenticatedDATRedirect(pendoPayload)
          }

          navigate(location.pathname, { replace: true })
        }

      } catch (error) {
        // eslint-disable-next-line no-console
        console.log('Error trying to handle DAT booking redirect', error)
      }
    }
  }

  return { getDATRedirectQueryParam, handleDatBookingRedirect }
}
